import React, { useState } from 'react';
import { TextField, Typography } from '@mui/material';
import HeaderWithActions from '../../../../../../../lib/designSystem/HeaderWithActions';
import EnhacedBox from '../../../../../../../lib/designSystem/Box';
import {
  showAlert,
  validatePermissions,
} from '../../../../../../../lib/functions/utils';
import { updateBusinessSummary } from '../../../../../../../lib/api';
import { useDispatch } from 'react-redux';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';

type ObservationsProps = {
  user: any;
  observations: string;
  businessIdentifier: string;
  setUp: () => void;
};

const Observations = (props: ObservationsProps) => {
  const { user, observations, businessIdentifier, setUp } = props;
  const dispatch = useDispatch();
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [observationsInEdition, setObservationsInEdition] =
    useState(observations);

  const handleSave = async () => {
    try {
      setLoading(true);
      const data = {
        observations: observationsInEdition,
      };
      await updateBusinessSummary(dispatch, businessIdentifier, data);
      showAlert(dispatch, 'success', 'Información actualizada correctamente');
      await setUp();
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al actualizar la información');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <CenteredCircularProgress relative />;

  return (
    <>
      {!editing && (
        <>
          <HeaderWithActions
            variant="body1"
            subHeader
            buttons={[
              {
                action: () => setEditing(true),
                name: 'Editar',
                color: 'secondary' as const,
              },
            ]}
            title="Observaciones"
          />
          <EnhacedBox>
            <Typography
              variant="body1"
              sx={{
                wordBreak: 'break-word',
                whiteSpace: 'pre-wrap',
              }}
            >
              {observations}
            </Typography>
          </EnhacedBox>
        </>
      )}
      {editing && (
        <>
          <HeaderWithActions
            variant="body1"
            subHeader
            buttons={[
              {
                action: () => setEditing(false),
                name: 'Cancelar',
                color: 'secondary' as const,
              },
              {
                action: () => handleSave(),
                color: 'warning' as const,
                disabled: !validatePermissions(user, 'businesses_create_new'),
                name: 'Guardar',
              },
            ]}
            title="Observaciones"
          />
          <div style={{ margin: '0px 12px 0px 0px', backgroundColor: '#ffffff' }}>
            <TextField
              value={observationsInEdition}
              onChange={(e) => setObservationsInEdition(e.target.value)}
              variant="outlined"
              multiline
              fullWidth
              disabled={!editing}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '10px',
                },
              }}
              InputProps={{
                sx: {
                  '& textarea': {
                    minHeight: 215,
                  },
                },
              }}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Observations;
